import React, { useState, useEffect } from "react";
import { 
	List, 
	Space, 
	Button, 
	Drawer, 
	message, 
	Popconfirm,
	Transfer,
	Modal,
	Input,
	Row,
	Col,
	theme
} from "antd";
import { 
	QuestionCircleOutlined,
	EditOutlined,
} from "@ant-design/icons";
import { useCalculateListSizeForPaginationHook } from "../hooks";
import { get_users, edit_user, get_companies, get_databases } from "../services";
import PropTypes from "prop-types";
import { CircleAnimationCompact } from "../components/loading";
import { hover_item } from "../hover";

const no_selected_user = {
	name: "",
	email: "",
	assigned_companies: [],
	assigned_databases: [],
};

const empty_credentials = {
	database_user: "",
	key: ""
};

export const Users = ({token, user, setUser, refreshCompanies}) => {

	const { token : antToken } = theme.useToken();

	const [loading, setLoading] = useState(true);
	const [loadingSubmit, setLoadingSubmit] = useState(false);	
	const [users, setUsers] = useState([]);
	const [open, setOpen] = useState(false);
	const [openEditCompanies, setOpenEditCompanies] = useState(false);
	const [openEditModal, setOpenEditModal] = useState(false);
	const placement = "right";
	const [selected, setSelected] = useState(no_selected_user);
	const [selectedKeysCompanies, setSelectedKeysCompanies] = useState([]);
	const [selectedKeysDatabases, setSelectedKeysDatabases] = useState([]);
	const [clientCompanies, setClientCompanies] = useState([]);
	const [clientDatabases, setClientDatabases] = useState([]);
	const [originalDatabases, setOriginalDatabases] = useState([]);
	
	const { pageSize } = useCalculateListSizeForPaginationHook(70);

	const [hoveredItem, setHoveredItem] = useState(null);
	const [detectedErrors, setDetectedErrors] = useState([]);
	const [selectedCredential, setSelectedCredential] = useState("");
	const [credentials, setCredentials] = useState([]);
	const [userDatabases, setUserDatabases] = useState([]);
	const [auxiliarInput, setAuxiliarInput] = useState(empty_credentials);

	const joinDatabasesInformation = (user_databases) => {
		const databasesFiltered = user_databases.map((secondItem) => {
			const itemsMatched = clientDatabases.find(
				(firstItem) => firstItem.id === secondItem
			);

			if(itemsMatched) {
				return itemsMatched;
			}
		});
		return databasesFiltered;
	};

	const companiesAllowedByDB = (data_assigned_databases) => {
		const data_to_filter = (data_assigned_databases === undefined) ? selected.assigned_databases : data_assigned_databases;

		const companiesFiltered = data_to_filter.flatMap((item) => {
			const itemsMatched = clientDatabases.find(
				(itemToMatch) => itemToMatch.id === item
			);
			
			if(itemsMatched){
				const founded_company = itemsMatched.assigned_companies.flatMap((company) => {
					const found = clientCompanies.find(
						(client_company) => client_company.id === company
					);
					
					return found ? { ...found } : null;
				});
				
				return founded_company;
			}
		});
		
		setOriginalDatabases(companiesFiltered.filter((item) => item !== null));
	};
	
	const prepareUserDatabases = (item) => {		
		setUserDatabases(joinDatabasesInformation(item.assigned_databases));
	};
	
	const handleChangeAssignedCompanies = (newTargetKeys) => {
		setSelected({...selected, assigned_companies: newTargetKeys});
	};

	const handleSelectChangeCompanies = (sourceSelectedKeys, targetSelectedKeys) => {
		setSelectedKeysCompanies([...sourceSelectedKeys, ...targetSelectedKeys]);
	};

	const handleChangeAssignedDataBases = (newTargetKeys) => {
		const db_refactored = newTargetKeys.map((db_id) => {
			const itemMatch = clientDatabases.find(
				(item) => item.id === db_id
			);

			return itemMatch;
		});

		setUserDatabases(db_refactored);
		setSelected({
			...selected,
			assigned_databases: db_refactored.map((db)=> db.id)
		});
	};

	const handleSelectChangeDatabases = (sourceSelectedKeys, targetSelectedKeys) => {
		setSelectedKeysDatabases([...sourceSelectedKeys, ...targetSelectedKeys]);
	};

	const showDrawer = () => {
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
		setSelected(no_selected_user);
		setSelectedCredential("");
		setCredentials([]);
		setSelectedKeysCompanies([]);
		setSelectedKeysDatabases([]);
		setUserDatabases([]);
		setOriginalDatabases([]);
		setDetectedErrors([]);
	};

	const submitChanges = async () => {
		
		setLoadingSubmit(true);
		try {
			setDetectedErrors([]);

			const user_notification = {
				email: selected.email,
				assigned_companies: selected.assigned_companies,
				assigned_databases: selected.assigned_databases,
				credentials
			};

			const edited = await edit_user(token, user_notification, "org");
			if (edited) {
				const new_users = users.map(u => u.email == selected.email ? selected : u);
				setUsers(new_users);
				if (selected.email == user.email) {
					setUser(
						{...user, 
							assigned_companies: selected.assigned_companies, 
							assigned_databases: selected.assigned_databases
						});
					refreshCompanies();
					if(selected.assigned_databases.length === 0){
						onClose();
					}
					else {
						companiesAllowedByDB(selected.assigned_databases);
						setOpenEditCompanies(true);
					}
				}
				// Assigned Companies ready and done
				if(openEditCompanies){
					setOpenEditCompanies(false);
					onClose();
				}
			}
			setLoadingSubmit(false);
		} catch (error) {
			console.error(error);
			message.error("Error Editing Company");
			setLoadingSubmit(false);
		}
	};

	const deleteUser = async () => {
		try {
			setLoading(true);
			let res = await edit_user(token, selected, "org");
			if (res) {
				if (res.status == 200) {
					message.success(res.data);
					onClose(); 
				} else {
					message.error(res.data);
				}
				res = await get_users(token, "org");
				if (res) {
					setUsers(res);
					setLoading(false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	const updateCredentials = (credentials, selectedCredential, auxiliarInput) =>  {
		// Verificar si la database_id ya existe en las credenciales
		const existingIndex = credentials.findIndex(credential => credential.database_id === selectedCredential);
	
		if (existingIndex !== -1) {
			// Si la database_id ya existe, actualizamos esa entrada
			credentials[existingIndex] = {
				"database_id": selectedCredential,
				"database_user": auxiliarInput.database_user,
				"key": auxiliarInput.key
			};
		} else {
			// Si la database_id no existe, agregamos una nueva entrada
			credentials.push({
				"database_id": selectedCredential,
				"database_user": auxiliarInput.database_user,
				"key": auxiliarInput.key
			});
		}
	
		// Aquí puedes usar tu función para actualizar el estado o lo que necesites hacer con las credenciales actualizadas
		setCredentials(credentials);
	};

	const processEdit = () => {
		if(auxiliarInput.database_user.trim() === "" || auxiliarInput.key.trim() === ""){
			message.warning("Porfavor llene la información de todos los inputs.");
			return;
		}

		updateCredentials(credentials, selectedCredential, auxiliarInput);

		setSelectedCredential("");
		setAuxiliarInput(empty_credentials);
		setOpenEditModal(false);
		message.info("Debe seleccionar Enviar para guardar sus cambios");
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Ejecuta todas las solicitudes en paralelo
				const [resUsers, resCompanies, resDatabases] = await Promise.all([
					get_users(token, "org"),
					get_companies(token, "is_associated"),
					get_databases(token)
				]);
	
				// Procesa la respuesta de usuarios
				if (resUsers) {
					// Ordena los usuarios alfabéticamente por el campo 'name'
					const sortedUsers = resUsers.sort((a, b) => {
						if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
						if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
						return 0;
					});
					setUsers(sortedUsers);
				}
	
				// Procesa la respuesta de compañías
				if (resCompanies) {
					setClientCompanies(resCompanies.map((company) => {
						return {
							name: company.name,
							id: company.id,
							key: company.id,
							tid: company.tid,
						};
					}));
				}
	
				// Procesa la respuesta de bases de datos
				if (resDatabases) {
					setClientDatabases(resDatabases.map((database) => {
						return {
							name: database.name,
							key: database.id,
							active: database.active,
							system: database.system,
							version: database.version,
							id: database.id,
							assigned_companies: database.assigned_companies,
							database_user: "",
							genereted_key: "",
						};
					}));
				}
	
				setLoading(false);
			} catch (error) {
				console.error(error);
			}
		};    
	
		fetchData();
	}, []);
    
	return (
		<>
			{
				loading &&
				<CircleAnimationCompact/>
			}
			{
				!loading &&
				<>
					<List
						pagination={{
							position:"top",
							align:"end",
							defaultPageSize:"7",
							pageSize:pageSize
						}}
						header={
							<Row
								style={{
									background: antToken.colorBgLayout,
									borderRadius: "10px"
								}}
							>
								<Col flex="auto">
									<List.Item key={0} >
										<List.Item.Meta 
											title="Nombre"
										/>
										<List.Item.Meta  
											title="Correo Electrónico" 
										/>
									</List.Item>
								</Col>
							</Row>
						}
						dataSource={users}
						renderItem={(item, index) => (
							<List.Item
								key={index}
								onMouseEnter={() => setHoveredItem(index)}
								onMouseLeave={() => setHoveredItem(null)}
								className={hoveredItem === index ? "hovered-item" : ""}
								onClick={() => {showDrawer(); setSelected(item); prepareUserDatabases(item);}}
								style={hover_item(hoveredItem === index, antToken, "invoices", 45)}
							>
								<List.Item.Meta
									title={item.name}
								/>          
								<List.Item.Meta
									description={item.email}
								/>          
							</List.Item>
						)}
					/>
				</>
			}

			<Drawer
				title="Editar Usuario"
				placement={placement}
				width={800}
				onClose={onClose}
				open={open}
				extra={
					<Space>
						<Button 
							onClick={() => {onClose(); setSelected(no_selected_user);}}
							loading={loadingSubmit}
						>
							Cancelar
						</Button>
						<Popconfirm
							title="Eliminar Usuario"
							description="Estas seguro que quieres eliminar este usuario?"
							onConfirm={() => {deleteUser();}}
							icon={<QuestionCircleOutlined style={{ color: "red" }} />}
						>
							<Button type="primary" danger loading={loadingSubmit}>
								Eliminar
							</Button>
						</Popconfirm>
						<Button type="primary" loading={loadingSubmit} onClick={() => {submitChanges();}}>
							Guardar
						</Button>
					</Space>
				}
			>					
				<div>
					{detectedErrors.length !== 0 && <h3 style={{color: "red"}}>Errores detectados y que corregir:</h3>}
					{detectedErrors.length !== 0 && detectedErrors.map((message_error, index) => (
						<p key={index} style={{color: "red"}}>&#x2022; {message_error}</p>
					))}
				</div>
				<div><h3>Nombre: </h3><p>{selected.name}</p></div>
				<div><h3>Correo: </h3><p>{selected.email}</p></div>
				<div><h3>Asignación de Bases de datos:</h3></div>
				<Transfer
					dataSource={clientDatabases.filter(db => db.active == true)}
					listStyle={{
						width: 350,
						height: 300,
					}}
					showSearch
					filterOption={(inputValue, item) =>
						item.name.toLowerCase().includes(inputValue.toLowerCase())
					}
					titles={["Bases de Datos Disponibles", "Bases de Datos Asignadas"]}
					targetKeys={userDatabases? userDatabases.map((db => db.id)): []}
					selectedKeys={selectedKeysDatabases}
					onChange={handleChangeAssignedDataBases}
					onSelectChange={handleSelectChangeDatabases}
					render={(item) => { return (`${item.name} - ${item.system} v${item.version}`); }}
					style={{
						marginBottom: 16,
						marginTop:"10px"
					}}
				/>
				{(userDatabases.length !== 0 &&
					<div>
						<h3>Asignación de Credenciales:</h3>
						<div style={{
							backgroundColor: antToken.colorBgLayout,
							borderRadius: "10px",
							width: "95%",
							height: "150px",
							overflowX: "hidden",
							overflowY: "auto",
							textAlign: "center",
							padding: "20px",
						}}>
							{/* O talvez esto */}
							{userDatabases.map((item, index) => {
								return (
									<>
										<p key={index}>{`${item.name} - ${item.system} v${item.version}. Estado: `}</p>
										<Space>
											<Button
												type="default"
												icon={<EditOutlined />}
												size="small"
												onClick={() => {
													setSelectedCredential(item.id);
													/* setAuxiliarInput({
														database_user: item.database_user,
														key: item.genereted_key
													}); */
													setOpenEditModal(true);}
												}
											/>
										</Space>
									</>
								);
							})}
						</div>
					</div>					
				)}
				<br/>
				<div>
					<Button
						disabled={(selected.assigned_databases.length === 0)}
						onClick={() => {
							setOpen(false);
							setOpenEditCompanies(true);
							companiesAllowedByDB();
						}}
					>						
						{`${(selected.assigned_databases.length === 0) ? 
							"Debes asignar una Base de Datos primero" : 
							"Asignar Compañias"}`
						}
					</Button>
				</div>
			</Drawer>
			<Drawer
				title="Asignar Compañías"
				placement={placement}
				width={800}
				onClose={() => {
					setOpenEditCompanies(false);
				}}
				open={openEditCompanies}
				extra={
					<Space>
						<Button onClick={() => {
							setOpen(true);
							setOpenEditCompanies(false);
						}}>Regresar</Button>
						<Button type="primary" loading={loadingSubmit} onClick={() => {submitChanges();}}>
              Guardar
						</Button>
					</Space>
				}
			>				
				<div><h3>Asignación de Compañías:</h3></div>
				<Transfer
					dataSource={originalDatabases}
					listStyle={{
						width: 350,
						height: 300,
					}}
					showSearch
					filterOption={(inputValue, item) =>
						item.name.toLowerCase().includes(inputValue.toLowerCase())
					}
					titles={["Compañías Disponibles", "Compañías Asignadas"]}
					targetKeys={selected.assigned_companies}
					selectedKeys={selectedKeysCompanies}
					onChange={handleChangeAssignedCompanies}
					onSelectChange={handleSelectChangeCompanies}
					render={
						(item) => item.name
					}
					style={{
						marginBottom: 16,
						marginTop:"10px"
					}}
				/>
				<div><h3>Bases de datos Asignadas:</h3></div>
				<div>
					{joinDatabasesInformation(selected.assigned_databases).map((item, index) => (
						<p key={index}>{`${item.name} - ${item.system} v${item.version}`}</p>
					))}
				</div>
			</Drawer>
			<Modal
				title={"Editar Credenciales"}
				open={openEditModal}
				onOk={processEdit} 
				onCancel={() => {setOpenEditModal(false); setAuxiliarInput(empty_credentials); setSelectedCredential("");}}
			>
				<h3>Correo:</h3>
				<Input
					rows={1}
					showCount
					status={(auxiliarInput.database_user.trim() === "") ? "error" : ""}
					value={auxiliarInput.database_user}
					onChange={(event) => setAuxiliarInput({...auxiliarInput, database_user: event.target.value})}
				/>
				<h3>Key:</h3>
				<Input
					rows={1}
					showCount
					status={(auxiliarInput.key.trim() === "") ? "error" : ""}
					value={auxiliarInput.key}
					onChange={(event) => setAuxiliarInput({...auxiliarInput, key: event.target.value})}
				/>
			</Modal>
		</>
        
	);
};

Users.propTypes = {
	token: PropTypes.string.isRequired,
	user: PropTypes.object.isRequired,
	setUser: PropTypes.func.isRequired,
	refreshCompanies: PropTypes.func.isRequired,
};
